import React from 'react';
import PropTypes from 'prop-types';
import { Trans, withNamespaces } from 'react-i18next';
import config from '../envConfig/config';
import AppUrls from '../config/AppUrls';
import { companyName, PanelType } from '../utils/Constants';

import RectangleIcon from '../assets/img/rectangle-home.svg';
import { getLoginGridColumnsLeftClasses, getLoginGridColumnsRightClasses } from '../utils/themeAndStyleHelpers';
import { isPanelType, isZimoPanel } from '../utils/panelUtils';

const logoUrls = config.REACT_APP_LOGO_URL;
const LoginLayout = ({ children }) => {
  const gridColumnsRightClass = getLoginGridColumnsRightClasses();
  const gridColumnsLeftClass = getLoginGridColumnsLeftClasses();

  return (
    <main className="container-fluid h-100">
      <div className="row h-100">
        <div className={`${gridColumnsLeftClass} home-img d-none d-lg-block position-button pl-0`}>
          {isPanelType(PanelType.DIRECTA) && !isZimoPanel && (
            <>
              <div className="home-rectangle">
                <img src={RectangleIcon} alt="" className="w-90" />
              </div>
              <h2 className="home-rectangle home-text text-light pl-4 w-90">
                <Trans i18nKey="titleHomeLogin">
                  Different look, same environment
                  <br />
                  Boost your business
                </Trans>
              </h2>
              <footer className="home-footer">
                <div className="row align-items-center">
                  <div className="col-1">
                    <img src={`${AppUrls.resources.logos}directa-logo-crop-white.png`} alt={companyName} className="logo" />
                  </div>
                  <div>
                    <strong className="h3 text-white font-weight-bold">
                      <Trans i18nKey="homeSlogan">
                        Boost your
                        <br />
                        Business
                      </Trans>
                    </strong>
                  </div>
                </div>
              </footer>
            </>
          )}
        </div>
        <div className={`${gridColumnsRightClass} home-content`}>
          <div className="text-center home-logo-container">
            <img src={`${logoUrls.defaultLogoLogin}`} alt={companyName} className="home-logo" />
          </div>
          {children}
        </div>
      </div>
    </main>
  );
};

LoginLayout.propTypes = {
  children: PropTypes.node,
};

LoginLayout.defaultProps = {
  children: null,
};

export default withNamespaces()(LoginLayout);
